import { MediaUploadPrepareStatus } from "../types/media";
import OverlayRoot from "./shared/OverlayRoot";


interface UploadPrepareOverlayProps {
  status: MediaUploadPrepareStatus;
  onDismiss?: () => void;
}

function UploadPrepareOverlay({ status, onDismiss }: UploadPrepareOverlayProps) {
  if (status.phase === "idle") {
    return null;
  }

  const processingPercent =
    status.phase === "processing" && status.total > 0
      ? Math.max(1, Math.round((status.processed / status.total) * 100))
      : 0;

  return (
    <OverlayRoot
      data-section="upload-prepare-overlay"
      className="fixed inset-0 z-40 flex items-end justify-center bg-black/45 px-4 pb-8 pt-24 sm:items-center sm:p-6 overscroll-none"
    >
      <div className="w-full max-w-md rounded-3xl border border-white/20 bg-[rgba(8,19,29,0.92)] px-5 py-5 shadow-2xl backdrop-blur-xl">
        <div className="flex items-start gap-4">
          <div className="mt-0.5 h-8 w-8 flex-shrink-0 rounded-full border-2 border-white/25 border-t-white animate-spin" />
          <div className="min-w-0 flex-1">
            <p className="text-white font-semibold">
              {status.phase === "processing" ? "Starting uploads" : "Getting your media ready"}
            </p>
            <p className="mt-1 text-sm text-gray-300">
              {status.phase === "processing"
                ? `${status.processed} of ${status.total} files · ${processingPercent}%`
                : "Large selections can take a while after you tap Done. Uploads have not started yet."}
            </p>
            <div className="mt-3 h-2 overflow-hidden rounded-full bg-white/15">
              <div
                className={`h-full jp-gradient-progress ${
                  status.phase === "processing" ? "transition-all duration-300 ease-out" : "animate-pulse"
                }`}
                style={{
                  width: status.phase === "processing" ? `${processingPercent}%` : "100%",
                  opacity: status.phase === "processing" ? 1 : 0.55,
                }}
              />
            </div>
            {status.phase === "waiting-for-files" && onDismiss && (
              <button
                type="button"
                onClick={onDismiss}
                className="mt-3 text-sm font-medium text-gray-300 hover:text-white transition-colors"
              >
                Dismiss
              </button>
            )}
          </div>
        </div>
      </div>
    </OverlayRoot>
  );
};

export default UploadPrepareOverlay;

